import featureFlags, { allowRead } from "@/__main__/feature-flags.mjs";
import blitzMessage, { EVENTS } from "@/__main__/ipc-core.mjs";
import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";
import { devError } from "@/util/dev.mjs";
import globals from "@/util/global-whitelist.mjs";

let reportTimeInterval = null,
  collectTimeInterval = null,
  data = [];
const TIME_OUT_REPORT = 1000 * 60 * 10,
  TIME_OUT_COLLECT = 1000 * 60;

// Used for collect memory usage data every 1 minute, data team want to see more memory usage information.
const collectRamData = () => {
  const { process } = globals.__BLITZ__;
  const v8HeapInfo = process.getHeapStatistics();
  data.push({
    ram: v8HeapInfo.usedHeapSize * 1024,
    t: new Date(),
  });
  collectTimeInterval = setTimeout(() => collectRamData(), TIME_OUT_COLLECT);
};

// Report data logs to server, every 10 minutes
const run = async () => {
  try {
    const { process } = globals.__BLITZ__;
    const nodeInfo = await blitzMessage(EVENTS.GET_RESOURCE_INFO);

    const processMemory = await process.getProcessMemoryInfo();
    const blinkMemoryUsage = process.getBlinkMemoryInfo();
    const v8HeapInfo = process.getHeapStatistics();
    allowRead();
    const adsEnabled = featureFlags.ads;
    // Note(Liz3): Electron memory is reported in Kilobytes which is why need to multiply by 1024,
    // the node memory info from the blitz event is in bytes.

    // new version
    refs.trackEvent(ANALYTIC_EVENTS.RESOURCE_USAGE_RAM_ARRAY, data);

    // old version
    refs.trackEvent(ANALYTIC_EVENTS.RESOURCE_USAGE, {
      node: nodeInfo,
      electron: {
        cpu: process.getCPUUsage(),
        blink: {
          allocated: blinkMemoryUsage.allocated * 1024,
          total: blinkMemoryUsage.total * 1024,
        },
        v8heap: {
          usedHeapSize: v8HeapInfo.usedHeapSize * 1024,
          totalHeapSize: v8HeapInfo.totalHeapSize * 1024,
          totalHeapSizeExecutable: v8HeapInfo.totalHeapSizeExecutable * 1024,
          totalPhysicalSize: v8HeapInfo.totalPhysicalSize * 1024,
          totalAvailableSize: v8HeapInfo.totalAvailableSize * 1024,
        },
        processMemory: {
          private: processMemory.private * 1024,
          shared: processMemory.shared * 1024,
        },
      },
      adsEnabled,
    });
    data = [];
  } catch (error) {
    devError("FAILED to report resource usage", error);
  }
  reportTimeInterval = setTimeout(() => run(), TIME_OUT_REPORT);
};

export const start = () => {
  if (!reportTimeInterval) {
    reportTimeInterval = setTimeout(() => run(), TIME_OUT_REPORT);
  }
  if (!collectTimeInterval) {
    collectTimeInterval = setTimeout(() => collectRamData(), TIME_OUT_COLLECT);
  }
};
export const stop = () => {
  if (reportTimeInterval) {
    clearTimeout(reportTimeInterval);
    reportTimeInterval = null;
  }
  if (collectTimeInterval) {
    clearTimeout(collectTimeInterval);
    collectTimeInterval = null;
  }
};
